module.exports = __webpack_public_path__ + "static/media/chest.05bac96a.png";